import { motion, useInView } from "framer-motion";
import { useRef } from "react";

/**
 * Reveal on scroll — a wrapper that fades + slides its children in when they enter the viewport.
 * Optional `stagger` cascades child reveals (children must be motion elements or use variants).
 */
export default function Reveal({
  children,
  delay = 0,
  y = 32,
  duration = 0.9,
  once = true,
  className = "",
  as = "div",
  amount = 0.2,
}) {
  const ref = useRef(null);
  const inView = useInView(ref, { once, amount });
  const MotionTag = motion[as] || motion.div;

  return (
    <MotionTag
      ref={ref}
      initial={{ opacity: 0, y }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y }}
      transition={{ duration, delay, ease: [0.16, 1, 0.3, 1] }}
      className={className}
    >
      {children}
    </MotionTag>
  );
}

export function RevealStagger({ children, staggerDelay = 0.08, className = "", once = true, amount = 0.2 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once, amount });

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      variants={{
        hidden: {},
        visible: { transition: { staggerChildren: staggerDelay } },
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export const revealItem = {
  hidden: { opacity: 0, y: 24 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] },
  },
};
